import React, { useEffect } from 'react';
import { allowedTwoDimensionalDataTableProps } from './_allowedPropTypes';

const componentClassName = 'two-dimensional-data-table';

const TwoDimensionalTable = props => {
  const {
    classNames = [],
    rowHeadings,
    columnHeadings,
    cells,
    noResultsContent
  } = props;

  if (![rowHeadings, columnHeadings, cells].every(fundamentalData => fundamentalData.length > 0)) {
    return noResultsContent;
  }

  const {
    renderPlaceholderCell = () => {
      const { headers, renderCellContent } = cells.find(cell => !!cell);
      return renderCellContent({ headers, classNames: ['invisible'] });
    }
  } = props;

  const mutableCellCollection = [...cells]; // cell data gets removed after being used
  const tableClasses = [...classNames, componentClassName];

  const renderFinalCellContent = ({ rowId, columnId }) => {
    for (let i = mutableCellCollection.length - 1; i >= 0; i -= 1) {
      const { [i]: { headers } } = mutableCellCollection;
      const {
        rowId: rowHeadingId,
        columnId: columnHeadingId
      } = headers;

      if (rowId === rowHeadingId && columnId === columnHeadingId) {
        const { renderCellContent } = mutableCellCollection.splice(i, 1).pop();
        return renderCellContent({ headers });
      }

      if (i === 0) {
        return renderPlaceholderCell({ headers });
      }
    }
  };

  useEffect(() => {
    if (mutableCellCollection.length > 0) {
      const cellsWithDuplicateHeaders = cells.reduce((duplicates, cell) => {
        const { headers: currentHeaders } = cell;

        const foundCellsWithCurrentHeaders = cells.filter(({ headers }) => (
          currentHeaders.rowId === headers.rowId
          && currentHeaders.columnId === headers.columnId
        ));

        return foundCellsWithCurrentHeaders.length > 1 ? [...duplicates, cell] : duplicates;
      }, []);

      // DO NOT POSSIBLY REMOVE THESE LOGS (unless you can add these data to the error somehow):
      console.log('Unused cells:', mutableCellCollection);
      console.log('rowHeadings:', rowHeadings);
      console.log('columnHeadings:', columnHeadings);
      console.log('found duplicate cells:', cellsWithDuplicateHeaders);

      const errorMessage = 'ERROR: Some cells could not be placed in the two dimensional data table. '
        + 'This usually indicates that the cell headers were not provided correctly, for example '
        + 'the provided cell headers are undefined, null, or the provided ID-s do not match with '
        + "any of the rows' or columns' for some other reason (e.g. typo). In rare cases, it could "
        + 'be caused by cells with duplicate row or column ID-s. See more details logged above.';

      console.error(errorMessage);
      // throw new Error(errorMessage);
    }
  });

  // TODO: reimplement this using semantic HTML
  return (
    <ul className={tableClasses.join(' ')}>
      {columnHeadings.map(({ columnId, columnHeadingContent }) => (
        <li className={`${componentClassName}--column`}>
          <header className={`${componentClassName}--column-heading`}>
            {columnHeadingContent}
          </header>

          <dl className={`${componentClassName}--row-group`}>
            {rowHeadings.map(({ rowId, rowHeadingContent }) => (
              <div key={rowId} className='definition-wrapper'>
                <dt className={`${componentClassName}--row-heading`}>
                  {rowHeadingContent}
                </dt>

                <dd className={`${componentClassName}--cell`}>
                  {mutableCellCollection.length > 0 ? renderFinalCellContent({ rowId, columnId }) : (
                    renderPlaceholderCell({ rowId, columnId })
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </li>
      ))}
    </ul>
  );
};

TwoDimensionalTable.propTypes = allowedTwoDimensionalDataTableProps;

export default TwoDimensionalTable;